// Checkout Forms
import {
  FIRST_NAME_DATA_STANDARDS,
  LAST_NAME_DATA_STANDARDS,
  SEARCH_UK_POSTCODE_BUTTON,
  POSTCODE,
} from 'checkout-forms/form/fields';
import getAddressFieldsConfig from 'checkout-forms/form/configs/address';

// Config
import urlConstants from '@constants/urlConstants';
import getInternationalPhoneNumberConfig from '@utils/lazy/internationalPhoneNumberConfig';

// Components
import CheckboxReduxWrapper from '@components/checkbox-redux-wrapper';

export const MY_JOHN_LEWIS_TERMS_AND_CONDITIONS = {
  component: CheckboxReduxWrapper,
  type: 'checkbox',
  name: 'termsConditions',
  label: 'I agree to join my John Lewis and receive communications for rewards and offers',
  id: 'termsConditions',
  required: true,
  validationMessageKeys: {
    required: 'Please confirm you accept the terms & conditions',
  },
  checkedValue: 'true',
};

export const TERMS_CONDITIONS_PRIVACY_NOTICE = {
  component: () => (
    <p data-testid="termsText">
      By joining you accept the my John Lewis{' '}
      <a href={urlConstants.JL_TERMS_CONDITIONS} rel="noopener noreferrer" target="_blank">
        terms & conditions
      </a>{' '}
      and our{' '}
      <a href={urlConstants.JL_PRIVACY_NOTICE} rel="noopener noreferrer" target="_blank">
        privacy notice
      </a>
      .
    </p>
  ),
  extra: true,
  name: 'privacy_terms',
};

export const MY_JOHN_LEWIS_ADDRESS_FORM_SIMPLE_ID = 'myJohnLewisAddressFormSimple';

export function getMyJohnLewisAddressFormSimpleConfig() {
  return {
    id: MY_JOHN_LEWIS_ADDRESS_FORM_SIMPLE_ID,
    submitButton: 'Join My John Lewis',
    fields: [MY_JOHN_LEWIS_TERMS_AND_CONDITIONS, TERMS_CONDITIONS_PRIVACY_NOTICE],
  };
}

export const MY_JOHN_LEWIS_ADDRESS_FORM_EDIT_ID = 'myJohnLewisAddressFormEdit';

export function getMyJohnLewisAddressFormEditConfig({
  countryCode,
  addressLines,
  maxAddressLines,
  actions,
  configExtras,
}) {
  const ADDRESS_FIELDS = getAddressFieldsConfig({
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
  });

  const PHONE_NUMBER = getInternationalPhoneNumberConfig();

  return {
    id: MY_JOHN_LEWIS_ADDRESS_FORM_EDIT_ID,
    submitButton: 'Join My John Lewis',
    fields: [
      FIRST_NAME_DATA_STANDARDS,
      LAST_NAME_DATA_STANDARDS,
      PHONE_NUMBER,
      ...ADDRESS_FIELDS,
      MY_JOHN_LEWIS_TERMS_AND_CONDITIONS,
      TERMS_CONDITIONS_PRIVACY_NOTICE,
    ],
  };
}

export const MY_JOHN_LEWIS_ADDRESS_FORM_NEW_ID = 'myJohnLewisAddressFormNew';

export function getMyJohnLewisAddressFormNewConfig({
  countryCode,
  addressLines,
  maxAddressLines,
  actions,
  configExtras,
  postcodeSearchFormVisible,
}) {
  const { searchForAnotherAddress } = actions;

  const searchForAnotherAddressButton = {
    ...SEARCH_UK_POSTCODE_BUTTON,
    // action: searchForAnotherAddress,
    props: {
      ...SEARCH_UK_POSTCODE_BUTTON.props,
      'data-testid': 'search-for-address-button',
      onClick: searchForAnotherAddress,
    },
  };

  const ADDRESS_FIELDS = !postcodeSearchFormVisible
    ? getAddressFieldsConfig({
        countryCode,
        addressLines,
        maxAddressLines,
        actions,
        configExtras,
        renderAddressFields: !postcodeSearchFormVisible,
      })
    : [];

  const PHONE_NUMBER = getInternationalPhoneNumberConfig();

  if (ADDRESS_FIELDS.length > 1) {
    const index = ADDRESS_FIELDS.findIndex((field) => field?.id === POSTCODE?.id);
    if (index >= 0) {
      ADDRESS_FIELDS[index].fieldExtra = searchForAnotherAddressButton;
    }
  }

  const TERMS = postcodeSearchFormVisible ? [] : [MY_JOHN_LEWIS_TERMS_AND_CONDITIONS, TERMS_CONDITIONS_PRIVACY_NOTICE];

  return {
    id: MY_JOHN_LEWIS_ADDRESS_FORM_NEW_ID,
    submitButton: 'Join My John Lewis',
    fields: [FIRST_NAME_DATA_STANDARDS, LAST_NAME_DATA_STANDARDS, PHONE_NUMBER, ...ADDRESS_FIELDS, ...TERMS],
  };
}
